// extracted by mini-css-extract-plugin
export var collapsedSummary = "_ni-0";